import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import "./index.css";
import "./animation.css";
import App from "./App/App";
import reportWebVitals from "./reportWebVitals";
import CssBaseline from "@material-ui/core/CssBaseline";
import theme from "./material/theme";
import { Provider } from "react-redux";
import { ThemeProvider } from "@material-ui/core/styles";
// rtl material
import { create } from "jss";
import rtl from "jss-rtl";
import { StylesProvider, jssPreset } from "@material-ui/core/styles";
import { store } from "./store";
import 'bootstrap/dist/css/bootstrap.min.css'


import 'swiper/swiper.min.css';
import 'swiper/swiper-bundle.css';


// Configure JSS
import {NotificationAlert} from "./components/common/notificationAlert";
import "react-toastify/dist/ReactToastify.css";

const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <StylesProvider jss={jss}>
        <CssBaseline />
        <Router>
          <Provider store={store}>
            <App />
            <NotificationAlert />
          </Provider>
        </Router>
      </StylesProvider>
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();
